export const rouxTopChromeHeight = 48;
export const rouxTopChromeHeightPixels = "48px";

export const rouxBottomChromeHeight = 80;
export const rouxBottomChromeHeightPixels = "80px";
